export default __webpack_public_path__ + "static/article-thumbnail-01-fc528d56d6db027d2b75b1906ca30f22.png";